export const UserImageSource = {
  GETTY: 'getty',
  BACKGROUND_UPLOAD: 'background_upload',
  GETTY_ILLUSTRATIONS: 'getty-illustrations',
  STORYBLOCKS_ILLUSTRATIONS: 'storyblocks-illustrations',
  PIXABAY_ILLUSTRATIONS: 'pixabay-illustrations',
  UPLOAD: 'upload',
  EMAIL_UPLOAD: 'email_upload',
  PIXABAY: 'pixabay',
  STORYBLOCKS: 'storyblocks',
  DRAWING: 'drawing',
  BRAND_LOGOS: 'brand-logos',
  BRAND_HALLOWEEN_TEMPLATE: 'brand-halloween-template',
  AI_TEXT_TO_IMAGE: 'AI_TEXT_TO_IMAGE',
  AI_REGENERATED_IMAGE: 'AI_REGENERATED_IMAGE',
  AI_CHAT_MODEL_ASSET: 'AI_CHAT_MODEL_ASSET',
  AI_EDIT: 'AI_EDIT',
};

export type UserImageSourceType = (typeof UserImageSource)[keyof typeof UserImageSource];
